(ns ncr.search.model
  (:require
   [cljs.core.async :refer-macros [go] :refer [<!]]
   [clojure.core.match :refer [match]]
   [com.rpl.specter :as sp]
   [ncr.etc.util :as u]
   [ncr.backend :as b]
   [ncr.widgets.datev]))

(defn- xform-attachment [in]
  (-> in
    (update :metadata u/transit-read)
    (update :auxdata u/transit-read)))

(defn- xform-fragment [in]
  (->> in
    (sp/transform [:properties] u/transit-read)
    (sp/transform [:referenceTimestamps :created] b/parse-utc-date-time)
    (sp/transform [:cachedAttachments sp/ALL] xform-attachment)
    (sp/setval [(sp/map-key :cachedAttachments)] :attachments)))

(defn- xform [in]
  (->> in
    (sp/transform [:stat :sum] u/bignumber)
    (sp/transform [:fragments sp/ALL] xform-fragment)))

(defn query [query-string]
  (go
    (u/error-m
      [result
       (<!
         (b/!query
           [:search {:queryString query-string}
            [[:fragments
              [:id :name :labels :folder :rank :writableHint :ownerWritableHint :promotedHint :revoked :owner :creator
               :readACL :writeACL
               [:referenceTimestamps [:created]]
               [:cachedAttachments [:id :fileName :metadata :auxdata]]
               :properties]]
             [:stat [:meta/typename :sum :count]]]]))]

      (let [{:keys [fragments stat]} (xform result)]
        {:fragments fragments
         :fragments-by-id (u/index-by :id fragments)
         :fragments-by-attachment
         (reduce
           (fn [acc {:keys [id attachments]}]
             (reduce
               (fn [acc attachment]
                 (assoc acc (get attachment :id) id))
               acc
               attachments))
           {}
           fragments)
         :stat stat}))))

(defn reload-attachments [{:keys [fragments-by-attachment] :as state} attachment-id]
  (go
    (u/if-ok
      [result
       (u/error-m
         [document-id
          (or (get fragments-by-attachment attachment-id) [:error :no-fragment])

          document
          (or (get-in state [:fragments-by-id document-id]) [:error :no-fragment])

          document'
          (<!
            (b/!query
              [:fragment_load {:reference document-id}
               [[:cachedAttachments [:id :fileName :metadata :auxdata]]]]))

          document'
          (as-> document' $
            (xform-fragment $)
            (select-keys $ [:attachments])
            (merge document $))]

         (-> state
           (update :fragments-by-id assoc document-id document)
           (update :fragments
             (fn [fragments]
               (map
                 (fn [original]
                   (if (= (:id original) (:id document))
                     document'
                     original))
                 fragments)))))]
      result
      state)))


